import apiService from "./BaseApi";
import store from "@/store";

const ENDPOINTS_BY_TYPE = {
  franchisee_id: {
    data: "reports/economy/franchisee/data"
  },
  client_id: {
    data: "reports/economy/clients/data"
  },
  unit_id: {
    data: "reports/economy/units/data"
  }
};

const EconomyReportService = {
  request(endpoint, data, date_time) {
    if (!endpoint) throw new Error("Endpoint de relatório de economia não configurado.");
    return apiService.post(endpoint, {
      data,
      date_time,
      currentUserId: store.state.currentUser?.uid
    });
  },
  data(data, date_time) {
    return this.request(ENDPOINTS_BY_TYPE[data.type]?.data, data, date_time);
  },
  calculate(data, date_time) {
    return this.data(data, date_time);
  }
};

export default EconomyReportService;
